import React from 'react';
import Legend, { Symbol } from '../components/Legend';
import { useRecoilValue } from 'recoil';
import { configState } from '../recoil/atoms';

export interface LegendContainerProps {
  symbols?: Symbol[];
  symbolsOnly?: boolean;
}

const LegendContainer: React.FunctionComponent<LegendContainerProps> = props => {
  const config = useRecoilValue(configState);
  return <Legend symbolsOnly={props.symbolsOnly} symbols={props.symbols || config.symbolLegend || []} />;
};

export default LegendContainer;
